<template>
  <transition name="bbp-bounce">
    <div
      v-if="hover === row.id || showToolbar"
      class="bbp-toolbar-menu"
      v-click-outside="closeToolbar"
    >
      <i class="bbp-icon-menu" @click="setDisplayToolbar($event, true)"/>
      <transition name="bbp-bounce">
        <div
          v-if="showToolbar"
          class="bbp-toolbar-menu-popup"
          :class="{
            'bbp-toolbar-menu-popup_triple': isNoTriple ? false : displayEditIcon && !row.disabled,
            'bbp-toolbar-menu-popup_left': left,
          }"
          :style="toolbarPosition"
        >
          <BBPToolbarTable
            :row="row"
            :rows="rows"
            :column="column"
            :index="index"
            :hover="hover"
            :showToolbar="showToolbar"
            :right="true"
            @update="updateItem"
            @delete="deleteItem"
            @copy="copyItem"
            @edit="editItem"/>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import BBPToolbarTable from '@/components/Main/BBPTable/BBPToolbarTable/BBPToolbarTable'
import {IN_PROGRESS_PROJECT} from '@/constants/projectStatuses'

export default {
  name: 'BBPToolbarMenu',
  components: {BBPToolbarTable},
  props: ['row', 'rows', 'column', 'index', 'hover', 'left'],
  data () {
    return {
      showToolbar: false,
      toolbarPosition: {}
    }
  },
  computed: {
    displayEditIcon () {
      const { showEdit = false } = this.column
      return this.row.status === IN_PROGRESS_PROJECT.id || showEdit
    },
    isNoTriple () {
      const { isNoTriple = false } = this.column
      return isNoTriple
    }
  },
  methods: {
    updateItem ({row, column, value}) {
      this.$emit('update', {row, column, value})
    },
    setDisplayToolbar (e, val) {
      this.showToolbar = val
      const position = e.target.getBoundingClientRect()
      if (position) {
        this.toolbarPosition = {
          position: 'fixed',
          top: position.top + 21 + 'px',
          left: position.left - (this.left ? 0 : 32) + 'px'
        }
      }
    },
    closeToolbar () {
      this.toolbarPosition = {}
      this.showToolbar = false
    },
    deleteItem (currentElem) {
      this.$emit('delete', currentElem)
    },
    editItem (currentElem) {
      this.$emit('edit', currentElem)
    },
    copyItem (currentElem) {
      this.$emit('copy', currentElem)
    },
    updateProject (currentElem) {
      this.$emit('updateProject', currentElem)
    }
  },
  watch: {
    hover () {
      if (!this.showToolbar) return
      setTimeout(() => {
        if (this.hover === this.row.id) return
        this.showToolbar = false
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-toolbar-menu {
    @include global-font;
    position: relative;
    width: 23px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-accent;
    font-size: 13px;
    cursor: pointer;

    &:hover {
      color: $color-accent-hover;
    }

    &-popup {
      position: absolute;
      top: calc(100% + 5px);
      padding: 12px;
      border-radius: 5px;
      width: 76px;
      box-shadow: 0 0 20px rgba($color-black, 0.05);
      background: $color-white;
      z-index: 5;

      &_left {
        left: 0;
      }

      &_triple {
        width: 109px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPToolbarMenu/BBPToolbarMenu.vue